import React, { Suspense } from 'react';
import { I18nextProvider, initI18n } from '@wix/wix-i18n-config';
import App from './components/App/App';
import { render } from 'react-dom';
import { HttpClientProvider } from '@wix/fe-essentials/react';
import { httpClient } from './utils/httpClient';
import { RootEssentialsProvider } from '@wix/fe-essentials-standalone/react';
import { createEssentials } from '@wix/fe-essentials-standalone';
import { WixDesignSystemProvider } from '@wix/design-system';
import { BrowserRouter } from 'react-router-dom';
import '@wix/design-system/styles.global.css';
import { TemplatesContextProvider } from './context/TemplatesContext';
import { NotificationsProvider } from './context/NotificationsContext';
import { BiContextProvider } from './context/BiContext';
import { APP_BASE_ROUTE } from './constants/routes';

const i18n = initI18n({
  locale: window.__LOCALE__,
  messages: window.__MESSAGES__,
});
const domNode =
  document.getElementById('root')! || document.createElement('div');
const essentials = createEssentials({
  environment: {
    language: window.__LOCALE__,
    artifactId: '',
    version: '',
  },
});
render(
  <Suspense fallback="...loading">
    <I18nextProvider i18n={i18n}>
      <RootEssentialsProvider essentials={essentials}>
        <BiContextProvider>
          <HttpClientProvider value={httpClient}>
            <BrowserRouter basename={APP_BASE_ROUTE}>
              <WixDesignSystemProvider features={{ newColorsBranding: true }}>
                <TemplatesContextProvider>
                  <NotificationsProvider>
                    <App />
                  </NotificationsProvider>
                </TemplatesContextProvider>
              </WixDesignSystemProvider>
            </BrowserRouter>
          </HttpClientProvider>
        </BiContextProvider>
      </RootEssentialsProvider>
    </I18nextProvider>
  </Suspense>,
  domNode,
);
